import { render, staticRenderFns } from "./SmzChiefs.vue?vue&type=template&id=288641b6"
import script from "./SmzChiefs.vue?vue&type=script&lang=js"
export * from "./SmzChiefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports